import RegisterComp from 'src/components/register'

export default RegisterComp
